import React, { useContext } from 'react'
import { FieldArrayRenderProps } from 'react-final-form-arrays'
import { Grid } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import classNames from 'classnames'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { ResponsiveContext } from '../../../utils/context/responsiveContext'
import CheckBoxField from '../../../components/fields/CheckBoxField'
import { InterlocuteurBailCRMModel } from '../../../types/contracts/contractsModel'

const useStyles = makeStyles<Theme, { isLargeScreen: boolean }>((theme) => ({
		...styles(theme),
		errorStyle: {
			color: '#B92D00',
			fontSize: 10
		},
		conteneurLabel: {
			marginBottom: 15
		}
	}
))

interface AcceptingProps {
	label: React.ReactChild,
	copreneurs: InterlocuteurBailCRMModel[],
	selectionMax: number
}

type SelecteurCopreneurProps =
	FieldArrayRenderProps<string, HTMLElement>
	& AcceptingProps

const SelecteurCopreneur: React.FC<SelecteurCopreneurProps> = (
	{
		fields,
		meta,
		label,
		copreneurs,
		selectionMax
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const classes = useStyles({ isLargeScreen })

	// Fonction pour check si le copreneur fait parti de la liste du formulaire
	const verificationSelectionCopreneur = (copreneurId: string) => {
		let indexCopreneur = -1

		fields.forEach((field, index) => {
			if (fields.value[index] === copreneurId) {
				indexCopreneur = index
			}
		})

		return indexCopreneur
	}

	// Fonction pour ajouter ou supprimer le copreneur de la liste du formulaire
	const gestionSelectionCopreneur = (copreneurId: string) => {
		if (verificationSelectionCopreneur(copreneurId) >= 0) {
			fields.remove(verificationSelectionCopreneur(copreneurId))
		} else {
			if (!fields.length || fields.length < selectionMax) {
				fields.push(copreneurId)
			}
		}
	}

	return (
		<Grid container item xs={12}>
			<Grid item xs={12} className={classes.conteneurLabel}>
				<span
					className={classNames(
						classes.text5,
						classes.colorBlue,
						{
							[classes.errorStyle]: meta.touched && meta.error
						}
					)}
				>
					{label}
				</span>
			</Grid>

			<Grid container item xs={12}>
				{
					copreneurs.map(
						(copreneur, index) => (
							<Grid item xs={12} md={4} key={copreneur.user_id}>
								<CheckBoxField
									input={{
										value: verificationSelectionCopreneur(copreneur.user_id) >= 0,
										checked: verificationSelectionCopreneur(copreneur.user_id) >= 0,
										onBlur: () => {
										},
										name: '',
										onChange: (e) => gestionSelectionCopreneur(copreneur.user_id),
										onFocus: () => {}
									}}
									meta={{
										error: '',
										submitError: ''
									}}
									label={`${copreneur.lastname} ${copreneur.firstname}`}
									color="colorBlue"
									name=""
									textStyle="text8"
								/>
							</Grid>
						)
					)
				}
			</Grid>
		</Grid>
	)
}

export default SelecteurCopreneur
